/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/246-confused': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M8 16A8 8 0 108 0a8 8 0 000 16zM8 1.5a6.5 6.5 0 110 13 6.5 6.5 0 010-13zM4 5a1 1 0 112 0 1 1 0 01-2 0zm6 0a1 1 0 112 0 1 1 0 01-2 0zm1.345 5h1.014a2.505 2.505 0 01-1.624 2.665 2.502 2.502 0 01-3.204-1.494 1.502 1.502 0 00-1.923-.896A1.502 1.502 0 004.655 12H3.642a2.505 2.505 0 011.624-2.665 2.502 2.502 0 013.204 1.494 1.502 1.502 0 001.923.896A1.502 1.502 0 0011.346 10z"/>'
  }
})
